import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Button from "../../Components/Button/Button";
import CarouselAndAudioPlayer from "../../Components/CarouselAndAudioPlayer/CarouselAndAudioPlayer";
import CropperModal from "../../Components/CropperModal/CropperModal";
import Header from "../../Components/Header/Header";
import Modal from "../../Components/Modal/Modal";
import Select from "../../Components/Select/Select";
import { createComplaints } from "../../Redux/complaints/action";
import { setErrorStatus } from "../../Redux/status/action";
import { isValidArray } from "../../Services/validators";
import { alignPhoneNumber } from "../../Utils/constants";

function CreateComplaint(props) {
  const [selectedLocationData, setSelectedLocationData] = useState(null);
  const [formData, setFormData] = useState({
    issue: []
  });
  const [file, setFile] = useState({
    image: [],
    audio: null
  });

  const [croppedImage, setCroppedImage] = useState({ images: [] });

  useEffect(() => {
    if (props.locations.selectedLocation) {
      setSelectedLocationData(
        props.locations.data?.[props.locations.selectedLocation]
      );
    }
  }, [props.locations.data, props.locations.selectedLocation]);

  const handleCreateComplaintsDisabled = useMemo(() => {
    const noIssue = formData.issue.length === 0;
    const noLocation = !selectedLocationData;
    const noMedia = croppedImage.images.length === 0 && file.audio === null;

    return noIssue || noLocation || noMedia;
  }, [formData.issue, croppedImage.images, file.audio, selectedLocationData]);

  return (
    <div className="inherit-parent-height inherit-parent-width overflow-hidden">
      <Header
        theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
        title="Create Complaint"
        backOnClick={() => {
          props.navigate("/complaints");
        }}
        profileOnClick={() => {
          props.navigate("/settings");
        }}
      />
      <div className="remaining-body-height inherit-parent-width display-flex flex-direction-column overflow-scroll hide-scrollbar">
        <div className="inherit-parent-width padding-large">
          <Fields
            title="RAISED BY"
            data={`${
              alignPhoneNumber(props.profile.data.phoneNumber) || "N/A"
            }  , ${props.profile.data.name || "N/A"}`}
          />
          <Fields
            title="LOCATION"
            data={`${selectedLocationData?.PCTNo} - ${selectedLocationData?.location}`}
          />
          <div
            className="margin-top-large"
            style={{
              height: "2px",
              width: "100%",
              backgroundColor: "#FFFFFF14"
            }}
          />
        </div>

        <div
          style={{
            height: "calc(100% - 100px)"
          }}
          className="inherit-parent-width padding-large flex-direction-column flex-justify-content-space-between"
        >
          <div>
            <div>
              <Select
                chips={formData?.issue}
                clearChips={() => {
                  setFormData({
                    ...formData,
                    issue: []
                  });
                }}
                modalTitle="Choose Category"
                multiSelect={true}
                name="category"
                label="ISSUES"
                onChipAdded={(data) => {
                  setFormData({
                    ...formData,
                    issue: [...data]
                  });
                }}
                languageData={false}
                data-cy="category-chip-input-box"
                options={[
                  "Restroom is not open",
                  "No water supply",
                  "Lights not working",
                  "Waterlogged in the drainage",
                  "Broken doors, latches",
                  "Lack of security measures",
                  "Janitors are not on duty",
                  "Unsanitary restroom",
                  "Fees are charged",
                  "Unhygienic environment"
                ]}
              />
            </div>

            <div
              style={{
                paddingBottom: croppedImage?.images.length > 0 ? "16px" : "0px"
              }}
              className="padding-top-large font-size-small"
            >
              UPLOAD FILES OR ADD VOICE NOTE
            </div>
            <div className="">
              <CarouselAndAudioPlayer
                // dataCy={data?.title}
                assetsLoading={props.complaintsLoading?.assets}
                setCroppedImage={setCroppedImage}
                fileSrc={croppedImage}
                dataCy="update-section"
                setFile={setFile}
                file={file}
                add={true}
                setErrorStatus={setErrorStatus}
                onImageClick={(data) => {
                  if (typeof props.setPreviewImage === "function") {
                    props.setPreviewImage(data);
                  }
                }}
              />
            </div>
          </div>

          <div className="">
            <Button
              type="button"
              text="CREATE COMPLAINT"
              boxShadow={false}
              loading={props.complaints.loading}
              disabled={handleCreateComplaintsDisabled}
              onClick={() => {
                createComplaints({
                  selectedLocation: props.locations.selectedLocation,
                  data: formData,
                  files: [...croppedImage.images, file.audio]
                });

                setFormData({
                  issue: []
                });
                setFile({
                  image: [],
                  audio: null
                });
                setCroppedImage({ images: [] });
              }}
              data-cy="CREATE-COMPLAINT-BUTTON"
            />
          </div>
        </div>
      </div>

      <Modal
        show={isValidArray(file?.image)}
        canIgnore={true}
        onClose={() => {
          setFile({ ...file, image: [] });
        }}
        width="inherit-parent-width"
        maxWidth="max-width-800px"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="inherit-parent-height max-height-500px"
      >
        <div
          data-cy="cropper-modal"
          className={`inherit-parent-height font-color-tertiaryColor6 background-color-tertiaryColor1`}
        >
          <CropperModal
            className="border-radius-default"
            OnBlobCreate={(blob) => {
              const imageFile = new File([blob], `${+new Date()}.png`, {
                type: "image/png"
              });
              setCroppedImage({
                images: [...croppedImage.images, imageFile]
              });
            }}
            file={file.image}
            setFile={() => {
              setFile({ ...file, image: [] });
            }}
          />
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    complaints: state.complaints,
    profile: state.profile,
    locations: state.locations
  };
};

const mapDispatchToProps = function () {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateComplaint);

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-large font-size-small">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "150px" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${
          !props.removeCapitalize && "text-capitalize"
        }`}
        data-cy={props.dataCy || props.data}
        style={{
          // minWidth: "fit-content",
          // maxWidth: "380px",
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};
